import { DATETIME_FORMATS, formatDateTime } from '@myap/ui-library'

const STYLE_ICON = { fontWeight: 700 }

const getFormattedAgreementDate = data => {
  const date = data?.dpaAgreement?.signingDate || data?.dateCompleted
  if (!date) {
    return ''
  }
  return formatDateTime(date, DATETIME_FORMATS.shortMonthDayYear)
}

const ApAgreementStatus = ({ srTitle, data }) => {
  const agreementDate = getFormattedAgreementDate(data)
  const signedBy = data?.dpaAgreement?.signee || data?.signedBy
  return (
    <>
      <h5>
        <span className="sr-only">{srTitle} </span>AP Agreement Status
      </h5>
      {signedBy && <div>Signed by {signedBy}</div>}
      {agreementDate && <div>{agreementDate}</div>}
      <div className="success-text" style={STYLE_ICON}>
        <i className="cb-glyph cb-check" aria-hidden={true} /> Signed
      </div>
    </>
  )
}

export default ApAgreementStatus
